import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { CompetitorsPhotoControlDataSource } from '../types'

const getOptions = (): Array<Column<CompetitorsPhotoControlDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap) as Array<keyof CompetitorsPhotoControlDataSource>

  return columnsKeys.map(key => {
    const column: Column<CompetitorsPhotoControlDataSource> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<CompetitorsPhotoControlDataSource>> => {
  return getColumnsFromMap<CompetitorsPhotoControlDataSource>({
    columnTitleMap,
    options: [...getOptions()]
  })
}
